import { Either } from 'fp-ts/lib/Either'
import { Option } from 'fp-ts/lib/Option'

export type ResultGetForCurrentUser = Either<Error, Option<OrderAggregation>>
export interface OrderAggregationRepository {
  /*
   * https://github.com/my-color/front/issues/7268
   * そもそも専用のAPIを立てれば「存在しない場合」についてそもそもClientで考慮する必要は無くなるが、
   * 以下の理由でAPI実装は省略して、Client側で考慮することにした.
   * - 実装内容的にはUserリソースのauxを引っこ抜くだけなので、わざわざAPIを建てるほどでもない
   *   - つまり、Userリソース以外にも色々参照する必要が出てきて複雑化するなら、APIを建てるべき
   * - そもそもGP側で注文集計データの連携処理を行うこと自体、本来回避したかったが止むに止まれずGP側で対応したに過ぎない
   *   - 集計データをいちいち取得して連携するまでもなく、必要に応じて集計した結果を使ってもらうのが一番良い
   *     - 詳細は https://github.com/my-color/front/issues/7268 のコメントを参照
   *   - よって、あまり実装としては頑張らずいつでも捨てられるようにしておく方向にした
   */
  /**
   * 現在ログインしているユーザーの注文集計データを取得する.<br/>
   * 初訪問ユーザーや購入履歴の無いユーザーである場合は、集計データがそもそも存在しない場合がある.
   *
   * @see https://github.com/my-color/front/issues/7268 背景
   */
  getForCurrentUser(): Promise<ResultGetForCurrentUser>
}

export type OrderAggregation = InitialOrderAggregation | StoredOrderAggregation

/**
 * 購入履歴無し（仮会員含む）のユーザーの注文集計データ
 */
interface InitialOrderAggregation {
  /** 最終購入日時 */
  readonly lastPurchasedDate: null
  /** 最終購入金額 */
  readonly lastPurchasedAmount: null

  /** 累計購入金額 */
  readonly totalPurchasedAmount: 0
  /** 累計購入回数 */
  readonly totalPurchasedCount: 0
}
export const initialOrderAggregation: InitialOrderAggregation = {
  lastPurchasedDate: null,
  lastPurchasedAmount: null,
  totalPurchasedAmount: 0,
  totalPurchasedCount: 0,
}
/**
 * 購入履歴があるユーザーの注文集計データ
 */
interface StoredOrderAggregation {
  /** 最終購入日時 */
  readonly lastPurchasedDate: Date
  /** 最終購入金額 */
  readonly lastPurchasedAmount: number

  /** 累計購入金額 */
  readonly totalPurchasedAmount: number
  /** 累計購入回数 */
  readonly totalPurchasedCount: number
}
